// extracted by mini-css-extract-plugin
export var compactFilters = "_fq-4";
export var detailImage = "_fq-1";
export var dropdownContainer = "_fq-2";
export var imageContainer = "_fq-0";
export var selectedCard = "_fq-3";